import DashboardMenuComponent from '@/components/dashboard-layout/dashboard-menu.component';
import LifetimeOfferBarComponent from '@/components/lifetime-offer/lifetime-offer-bar.component';
import LifetimeOfferPopupComponent from '@/components/lifetime-offer/lifetime-offer-popup.component';

interface Props {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: Props) {
  return (
    <div className="h-screen flex flex-col">
      {/* Lifetime offer CTA - renders nothing once the window closes. It sits
          outside the scrolling body so it stays put on every page. */}
      <LifetimeOfferBarComponent />

      <div className="flex-grow flex min-h-0">
        {/* Menu */}
        <div className="flex-[15rem_0_0] h-full overflow-hidden cl_secondary_background hidden md:block relative">
          <DashboardMenuComponent />
        </div>

        {/* Body */}
        <div className="flex-grow h-full overflow-y-auto">{children}</div>
      </div>

      <LifetimeOfferPopupComponent />
    </div>
  );
}
